// extracted by mini-css-extract-plugin
export default {"container":"OurSpace_page_container__u4yQ3","mainTitle":"OurSpace_page_mainTitle__cvjUh","description":"OurSpace_page_description__mwpps"};